import axios from 'axios'

function install (Vue) {
  Vue.prototype.$log = async (eventType, content = null, extra = null, context = sessionStorage.getItem('context'), occuredAt = new Date().toISOString()) => {
    if (!eventType) {
      console.error(`Missing 'eventType' parameter! (e.g. report_open, query_run, user_login etc.)`)
      return
    }

    if (extra && extra.constructor !== Object) {
      console.error(`The 'extra' parameter must be empty (null) or an object!`)
      return
    }

    const user = Vue.prototype.$auth.getUser()
    return axios({
      method: 'post',
      url: process.env.VUE_APP_API_URI + '/logs/log-action',
      headers: {
        'Content-Type': 'application/json'
      },
      data: {
        user_id: user.email,
        event_type: eventType,
        occured_at: occuredAt,
        context: context,
        content: content,
        extra: (extra && extra.constructor === Object && Object.entries(extra).length === 0) ? null : extra
      }
    }).catch(error => {
      console.error(error)
    })
  }
}

export default { install }
